import { useEffect, useRef, useState } from 'react';

export function fmtDur(s: number): string {
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60);
  return `${m}:${sec.toString().padStart(2, '0')}`;
}

export function useTickingDuration(initial: number): number {
  const [d, setD] = useState(initial);
  const startRef = useRef({
    wall: typeof performance !== 'undefined' ? performance.now() : Date.now(),
    base: initial,
  });

  useEffect(() => {
    startRef.current = {
      wall: typeof performance !== 'undefined' ? performance.now() : Date.now(),
      base: initial,
    };
    setD(initial);
  }, [initial]);

  useEffect(() => {
    const id = setInterval(() => {
      const now = typeof performance !== 'undefined' ? performance.now() : Date.now();
      const elapsed = (now - startRef.current.wall) / 1000;
      setD(startRef.current.base + elapsed);
    }, 250);
    return () => clearInterval(id);
  }, []);

  return d;
}

export function makeWaveBars(seed: string | number, n = 22): number[] {
  let h = 0;
  const s = String(seed);
  for (let i = 0; i < s.length; i++) h = ((h << 5) - h + s.charCodeAt(i)) | 0;
  const rng = () => {
    h = (h * 1664525 + 1013904223) | 0;
    return ((h >>> 0) % 10000) / 10000;
  };
  const bars: number[] = [];
  for (let i = 0; i < n; i++) {
    const env = Math.sin((i / n) * Math.PI) * 0.65 + 0.35;
    const noise = 0.3 + rng() * 0.7;
    bars.push(Math.max(0.22, Math.min(1, env * noise)));
  }
  return bars;
}

export function useNowMinute(): string {
  const [val, setVal] = useState(() =>
    new Date().toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }),
  );
  useEffect(() => {
    const id = setInterval(
      () => setVal(new Date().toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })),
      30000,
    );
    return () => clearInterval(id);
  }, []);
  return val;
}
